import { Component, Story, Knobs } from './DocTypes';

const PlaygroundKnobs: Knobs = {
  type: {
    default: 'danger',
    editor: 'dropdown',
    editorOptions: ['danger', 'warning', 'information'],
  },
  suppressArrow: {
    default: 'false',
    editor: 'checkbox',
  },
  device: {
    editor: 'dropdown',
    editorOptions: ['mobile', 'desktop', ''],
    default: '',
  },
};

const Playground: Story = {
  title: 'Playground',
  description: 'A simple input element with various attributes',
  coreComponent_v3: {
    html: `<tag3-input></tag3-input>
<tag3-validation-alert{{...knobs}}><div>Error</div></tag3-validation-alert>`,
    knobs: PlaygroundKnobs,
  },
  reactWrapper_v3: {
    jsx: `<div>
  <Tag3Input/>
  <Tag3ValidationAlert{{...knobs}}><div>Error</div></Tag3ValidationAlert>
</div>`,
    knobs: PlaygroundKnobs,
  },
};

export const TagValidationAlertDocs: Component = {
  type: 'component',
  name: 'validation-alert',
  description: 'Renders an validation alert element',
  mobileFriendly: true,
  popular: true,
  preRelease: '',
  props: [
    {
      name: 'type',
      description: 'The type of the input',
      type: "'danger' | 'warning' | 'information'",
    },
    {
      name: 'suppressArrow',
      description: 'Display the alert arrow',
      type: 'boolean',
    },
    {
      name: 'device',
      description: 'Set preferred styling theme for device type.',
      type: 'desktop | mobile',
      default: 'desktop',
    },
  ],
  reactPropOverrides: [],
  events: [],
  methods: [],
  stories: [Playground],
};
